import { atom } from "recoil";
import { Project } from "~/models/project";
import { QuestionAnswer } from "~/models/questionAnswer";
import { Task } from "~/models/task";
import { Topic } from "~/models/topic";

export interface QuestionAnswerState {
  answerContent: string;
  answerContentAmpHtml?: string;
  answerContentHtml?: string;
  answerContentWordCount: number;
  answerSummaryContent?: string;
  answerTableOfContentsHtml?: string;
  currentQuestionAnswer?: QuestionAnswer;
  displayStatus?: QuestionAnswer["displayStatus"];
  firstAnsweredUserId?: string;
  projectId: Project["id"];
  questionContent: string;
  questionAnswerId: string;
  questionerEmail?: string;
  questionPageViewCount: number;
  refererUrl?: string;
  requestedUserId?: string;
  requestedUserName?: string;
  talkRoomId?: string;
  taskStatus?: Task["status"];
  topicId: Topic["id"];
  topicName: Topic["name"];
  topicSlug: Topic["slug"];
  questionerUserId?: string;
}

export const initialQuestionAnswerState = {} as QuestionAnswerState;

export const questionAnswerStateAtom = atom({
  default: initialQuestionAnswerState,
  key: "AnswerState",
});

export function getQuestionContentErrorMessage(value?: string): string {
  if (!value || value?.length < 10 || value?.length > 80) {
    return "10文字以上、80文字以下にしてください";
  }

  return "";
}
